import ScrollReveal from '@/components/feature/ScrollReveal';

export default function LeadershipSection() {
  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Pruthvi Reddy',
    jobTitle: 'Co-Founder & CEO | Travel Tech Expert',
    worksFor: {
      '@type': 'TravelAgency',
      name: 'Lucky Holidays India Private Limited',
      url: 'https://www.luckyholidays.in/',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Pandian Street, Chinna Thirupathi, Salem',
        addressLocality: 'Hosur',
        addressRegion: 'Tamil Nadu',
        postalCode: '635109',
        addressCountry: 'IN',
      },
    },
    description: 'With a passion for travel, technology, and creating meaningful customer experiences, Pruthvi Reddy plays a key role in shaping the vision and growth of Lucky Holidays India. She brings a modern, technology-driven approach to travel while focusing on personalized service, smooth planning, and memorable journeys. Her vision is simple — make travel easier, smarter, more personal, and accessible for everyone.',
    image: 'https://luckyholidays.in/mam.jpeg',
    url: 'https://www.luckyholidays.in/#leadership',
    knowsAbout: ['International Travel', 'Domestic Tourism', 'Corporate Travel Management', 'Travel Technology', 'Customized Holiday Planning'],
  };

  return (
    <section id="leadership" className="py-16 md:py-24 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
      <div className="w-full px-4 md:px-8 lg:px-16 3xl:max-w-[1800px] 3xl:mx-auto tv:max-w-[3000px] tv:mx-auto">
        <div className="max-w-4xl tv:max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <ScrollReveal direction="left">
              <div className="flex-shrink-0">
                <div className="w-36 h-44 sm:w-40 sm:h-52 md:w-44 md:h-56 lg:w-48 lg:h-60 rounded-xl overflow-hidden bg-secondary-200 flex items-center justify-center card-hover-lift img-zoom-on-hover shadow-lg shadow-primary-100/40">
                  <img
                    alt="Pruthvi Reddy Co-Founder and CEO of Lucky Holidays India Private Limited travel technology expert"
                    title="Pruthvi Reddy - Co-Founder & CEO | Travel Tech Expert"
                    className="w-full h-full object-cover object-center"
                    src="https://luckyholidays.in/mam.jpeg"
                    loading="lazy"
                    itemProp="image"
                  />
                </div>
              </div>
            </ScrollReveal>
            <ScrollReveal direction="right" className="w-full text-center md:text-left">
              <span className="inline-block px-4 py-1.5 bg-accent-50 text-accent-700 text-xs font-semibold tracking-widest uppercase rounded-full mb-4">
                LEADERSHIP
              </span>
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl 3xl:text-5xl font-bold text-foreground-900 mb-2" itemProp="name">
                Pruthvi Reddy
              </h2>
              <p className="text-primary-500 font-medium text-sm md:text-base mb-4" itemProp="jobTitle">
                Co-Founder &amp; CEO | Travel Tech Expert
              </p>
              <div className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl tv:max-w-3xl space-y-4">
                <p>
                  With a passion for travel, technology, and creating meaningful customer experiences, Pruthvi Reddy plays a key role in shaping the vision and growth of Lucky Holidays India. She brings a modern, technology-driven approach to travel while focusing on personalized service, smooth planning, and memorable journeys.
                </p>
                <p>
                  Her vision is simple — make travel easier, smarter, more personal, and accessible for everyone.
                </p>
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-4 justify-center md:justify-start">
                <div className="flex items-center gap-2 text-foreground-600 text-xs group cursor-default">
                  <i className="ri-shield-check-line text-accent-500 group-hover-icon-bounce"></i>
                  <span>Travel Visionary</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-600 text-xs group cursor-default">
                  <i className="ri-earth-line text-accent-500 group-hover-icon-bounce"></i>
                  <span>Customer-Centric</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-600 text-xs group cursor-default">
                  <i className="ri-code-s-slash-line text-accent-500 group-hover-icon-bounce"></i>
                  <span>Travel Tech Expert</span>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}